import { render } from "./PremiumRecords.vue?vue&type=template&id=0a6be5c3&scoped=true"
import script from "./PremiumRecords.vue?vue&type=script&lang=js"
export * from "./PremiumRecords.vue?vue&type=script&lang=js"

import "./PremiumRecords.vue?vue&type=style&index=0&id=0a6be5c3&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6be5c3"]])

export default __exports__